export const ACCOUNT_SCOPE_DENIED_EVENT = 'jooice:account-scope-denied';
